#import "../fragments/email-sequence-template-fragment.graphql"

query GetUserEmailSequenceTemplates {
    emailSequenceTemplateCollection {
        userTemplates {
            ...EmailSequenceTemplate
        }
    }
}
